<template>
  <div class="main-block">
    <div>
      <el-form inline :model="formInfo" size="small" class="search-component">
        <el-row>
          <!-- <el-form-item label="项目编号：">
            <el-input v-model="formInfo.projectNo" placeholder="请输入项目编号"></el-input>
          </el-form-item>
          <el-form-item label="抵押登记编号：">
            <el-input v-model="formInfo.registrationNum" placeholder="请输入抵押登记编号"></el-input>
          </el-form-item>
          <el-form-item label="抵押人：">
            <el-input v-model="formInfo.mortgagorName" placeholder="请输入抵押人"></el-input>
          </el-form-item>
          <el-form-item label="抵押权人：">
            <el-input v-model="formInfo.mortgageHolderName" placeholder="请输入抵押权人"></el-input>
          </el-form-item>
          <el-form-item label="抵押物品名称：">
            <el-input v-model="formInfo.collateralName" placeholder="请输入抵押物品名称"></el-input>
          </el-form-item> -->
          <el-form-item label="区域：">
            <el-cascader v-model="formInfo.areaConfigId" :options="areaStatus" clearable></el-cascader>
            <!-- <el-select v-model="formInfo.areaConfigId" clearable>
              <el-option v-for="item in areaStatus" :key="item.areaConfigId"  
              :label="item.areaConfigName" :value="item.areaConfigId" ></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="抵押物名称：">
            <el-input v-model="formInfo.collateralName" placeholder="请输入抵押物品名称"></el-input>
            <!-- <el-select v-model="formInfo.collateralName" clearable>
              <el-option v-for="(item, key) in nameStatus"
                :key="key"  :label="item.label" :value="item.value" ></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="抵押状态：">
            <el-select v-model="formInfo.mortgageState" clearable>
              <el-option v-for="(item, key) in mortgageStatus" :key="key" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="登记时间：">
            <el-date-picker clearable
              v-model="formInfo.time"
              type="datetimerange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="getListData">搜索</el-button>
          </el-form-item>
        </el-row>
      </el-form>
      <div class="table">
        <el-table :data="tableData" v-loading="loading" style="width: 100%" border :header-cell-style="{ textAlign: 'center',  background: '#f8f9fb', color: '#394259' }" :cell-style="{ textAlign: 'center' }">
          <el-table-column prop="projectNo" label="项目编号"></el-table-column>
          <el-table-column prop="registrationNum" label="抵押登记编号"></el-table-column>
          <el-table-column prop="area" label="区域"></el-table-column>
          <el-table-column prop="mortgagorName" label="抵押人"></el-table-column>
          <el-table-column prop="mortgageHolderName" label="抵押权人"></el-table-column>
          <el-table-column prop="collateralName" label="抵押物名称"></el-table-column>
          <el-table-column prop="collateralLocation" label="抵押物所在地"></el-table-column>
          <el-table-column prop="loanMoney" label="贷款金额(万元)"></el-table-column>
          <el-table-column label="登记时间">
            <template v-slot="{ row }">{{row.registrationTime}}</template>
          </el-table-column>
          <el-table-column min-width="110" label="抵押期限">
            <template v-slot="{ row }">
              {{row.mortgageStartTime}}&nbsp;至&nbsp;
              {{row.mortgageEndTime}}
            </template>
          </el-table-column>
          <el-table-column label="抵押状态">
            <template v-slot="{ row }">{{row.mortgageState | mStatus}}</template>
          </el-table-column>
        </el-table>
      </div>
      <Pagination :total="paginationParam.total" :page.sync="paginationParam.pageIndex" :limit.sync="paginationParam.pageSize" @pagination="getListData" />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { dateFtt2 } from '@/utils/timeFormat.js'
export default {
  components: { Pagination },
  data() {
    return {
      tableData: [],
      paginationParam: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      areaStatus: [],
      nameStatus: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '1',
          label: '林权',
        },
        {
          value: '2',
          label: '农村土地',
        },
      ],
      mortgageStatus: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '1',
          label: '在押',
        },
        {
          value: '2',
          label: '解押',
        },
      ],
      formInfo: {
        // projectNo: "",
        // registrationNum: "",
        // mortgagorName: "",
        // mortgageHolderName: "",
        areaConfigId: '',
        collateralName: '',
        mortgageState: '',
        // time: ""
      },
      loading: false,
    }
  },
  filters: {
    mStatus: (str) => {
      if (str == 1) {
        return '在押'
      }
      if (str == 2) {
        return '解押'
      }
      return ''
    },
  },
  methods: {
    //获取抵押公告列表数据-待联调筛选和返回怇
    getListData() {
      this.loading = true
      const params = {
        ...this.formInfo,
        pageNumber: this.paginationParam.pageIndex,
        pageSize: this.paginationParam.pageSize,
        areaConfigId: this.formInfo.areaConfigId
          ? this.formInfo.areaConfigId[this.formInfo.areaConfigId.length - 1]
          : '',
      }
      this.$api.my
        .mortgageAnnounceList(params)
        .then((res) => {
          const data = res
          this.tableData = data.data
          this.paginationParam.total = data.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    init() {
      this.$api.my
        .getAeraAndType({ systemType: 3 })
        .then((res) => {
          if (res.data && res.data.aeras) {
            res.data.aeras.forEach((item, index) => {
              item.children = []
              item.children.push({ value: item.areaConfigId, label: '全部' })
              if (item.sonAreas) {
                item.sonAreas.forEach((items, indexs) => {
                  if (item.areaConfigName == items.city) {
                    item.children.push({
                      value: items.areaConfigId,
                      label: items.areaConfigName,
                      children: '',
                    })
                  }
                })
              }
              this.areaStatus.push({
                value: item.areaConfigId,
                label: item.areaConfigName,
                children: item.children,
              })
            })
          }
        })
        .catch((error) => {})
        .finally(() => {})
    },
  },
  async created() {
    window.scrollTo(0, 0)
    await this.getListData()
    await this.init()
  },
}
</script>

<style lang="scss" scoped>
.body {
  padding: 20px;
  background: #fff;
}
.container {
  .search-component {
    h4 {
      display: inline;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(57, 66, 89, 1);
      line-height: 26px;
      margin-right: 20px;
    }
  }
}
.el-form {
  /deep/ .el-form-item {
    margin-right: 20px;
  }
}
</style>